var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: {
      title: _vm.$t("productDetails"),
      hideRgtBtn: "",
      outsideScrollToBottom: _vm.outsideScrollToBottom,
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { id: "add_product" } },
              [
                _c(
                  "v-layout",
                  [
                    _c("v-flex", [
                      _c("span", { staticClass: "font-gray font-theme" }, [
                        _vm._v(_vm._s(_vm.product.condition))
                      ]),
                      _c("span", { staticClass: "font-theme" }, [
                        _vm._v(" " + _vm._s(_vm.product.name))
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c("v-flex", [
                      _c("span", { staticClass: "font-green" }, [
                        _vm._v("$ " + _vm._s(_vm.product.price))
                      ]),
                      _c("span", { staticClass: "font-gray" }, [
                        _vm._v(" - " + _vm._s(_vm.product.upc))
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-divider"),
                _vm._v(" "),
                _c(
                  "v-tabs",
                  {
                    attrs: { color: "transparent", "show-arrows": "" },
                    model: {
                      value: _vm.tab,
                      callback: function($$v) {
                        _vm.tab = $$v
                      },
                      expression: "tab"
                    }
                  },
                  [
                    _c("v-tabs-slider", { attrs: { color: "primary" } }),
                    _vm._v(" "),
                    _vm._l(_vm.tabs, function(tabItem) {
                      return _c("v-tab", { key: tabItem }, [
                        _vm._v(
                          "\n              " + _vm._s(tabItem) + "\n          "
                        )
                      ])
                    }),
                    _vm._v(" "),
                    _c(
                      "v-tabs-items",
                      {
                        attrs: { touchless: "" },
                        model: {
                          value: _vm.tab,
                          callback: function($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab"
                        }
                      },
                      _vm._l(5, function(item, index) {
                        return _c(
                          "v-tab-item",
                          { key: "item" + index },
                          [
                            index === 0
                              ? _c("ProductTable", {
                                  attrs: {
                                    product: _vm.distribution,
                                    type: index
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index === 1 && _vm.tab === 1
                              ? _c("PaginationController", {
                                  attrs: {
                                    getDataActionName: "getInboundForDetails",
                                    actionPayload: _vm.productInboundPayload,
                                    historyLimit: _vm.historyLimit,
                                    select: _vm.selectedUser,
                                    haveNoEndDate: true,
                                    refresh: _vm.refresh,
                                    outsideScrollToBottom: _vm.popupToBottom
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "dataTable",
                                        fn: function() {
                                          return [
                                            _c("v-data-table", {
                                              attrs: {
                                                headers: _vm.headersInbound,
                                                items: _vm.confirmedProduct,
                                                "item-key": "packageID",
                                                expand: _vm.expand,
                                                "hide-actions": ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "items",
                                                    fn: function(props) {
                                                      return [
                                                        _c(
                                                          "tr",
                                                          {
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                props.expanded = !props.expanded
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "subheading"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.index +
                                                                      1
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-xs-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .taskForTenant
                                                                      ? props
                                                                          .item
                                                                          .tenantName
                                                                      : props
                                                                          .item
                                                                          .userName
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-xs-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .siteName ||
                                                                      "warehouse"
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-xs-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .taskForTenant
                                                                      ? "/"
                                                                      : props
                                                                          .item
                                                                          .warehouse ===
                                                                        "self"
                                                                      ? props
                                                                          .item
                                                                          .price +
                                                                        props
                                                                          .item
                                                                          .bonus
                                                                      : props
                                                                          .item
                                                                          .price
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-xs-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .quantity
                                                                  )
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-xs-left"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.getDateString(
                                                                      props.item
                                                                        .createTime
                                                                    )
                                                                  )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      },
                                      index === 1 &&
                                      _vm.tab === 1 &&
                                      _vm.product.historyProductIds
                                        ? {
                                            key: "beforeMenu",
                                            fn: function() {
                                              return [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { md4: "" } },
                                                  [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        items:
                                                          _vm.historyProductIds,
                                                        label:
                                                          "Product history ID"
                                                      },
                                                      model: {
                                                        value: _vm.productId,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.productId = $$v
                                                        },
                                                        expression: "productId"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            },
                                            proxy: true
                                          }
                                        : null
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.confirmedProduct,
                                    callback: function($$v) {
                                      _vm.confirmedProduct = $$v
                                    },
                                    expression: "confirmedProduct"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index === 2 && _vm.tab === 2
                              ? _c("PaginationController", {
                                  attrs: {
                                    getDataActionName: "getHistoryTransfers",
                                    historyLimit: _vm.historyLimit,
                                    haveStartDate: true,
                                    actionPredicates: _vm.historyPredicates,
                                    refresh: _vm.refresh
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "dataTable",
                                        fn: function() {
                                          return [
                                            _c("v-data-table", {
                                              staticClass:
                                                "elevation-2 myDense",
                                              attrs: {
                                                headers: _vm.headerHistory,
                                                items: _vm.transfers,
                                                "hide-actions": ""
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "items",
                                                    fn: function(props) {
                                                      return [
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .transactionId
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .fromName
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .toName
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          _vm._l(
                                                            props.item.items,
                                                            function(
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "v-layout",
                                                                {
                                                                  key:
                                                                    "item" +
                                                                    index
                                                                },
                                                                [
                                                                  _c(
                                                                    "ProductWidget",
                                                                    {
                                                                      attrs: {
                                                                        name:
                                                                          item.name,
                                                                        condition:
                                                                          item.condition,
                                                                        upc:
                                                                          item.upc,
                                                                        asin:
                                                                          item.asin
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          ),
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          $" +
                                                                _vm._s(
                                                                  props.item
                                                                    .items[0]
                                                                    .unitPrice
                                                                ) +
                                                                "        \n                        "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  props.item
                                                                    .items[0]
                                                                    .toShip
                                                                ) +
                                                                "                 \n                        "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .location
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "td",
                                                          {
                                                            staticClass:
                                                              "text-xs-left"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.toTimestampString(
                                                                  props.item
                                                                    .createTime
                                                                )
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            })
                                          ]
                                        },
                                        proxy: true
                                      },
                                      {
                                        key: "beforeMenu",
                                        fn: function() {
                                          return [
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  sm8: "",
                                                  lg6: "",
                                                  "d-flex": "",
                                                  "align-baseline": ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-flex",
                                                  { attrs: { sm5: "" } },
                                                  [
                                                    _c("v-autocomplete", {
                                                      attrs: {
                                                        items: _vm.types,
                                                        label: "Type",
                                                        "item-text": "name",
                                                        "item-value": "type"
                                                      },
                                                      model: {
                                                        value: _vm.selectedType,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.selectedType = $$v
                                                        },
                                                        expression:
                                                          "selectedType"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c("v-flex", {
                                                  attrs: { sm1: "" }
                                                }),
                                                _vm._v(" "),
                                                _vm.selectedType !== 0
                                                  ? _c(
                                                      "v-flex",
                                                      { attrs: { sm6: "" } },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            "append-icon":
                                                              "filter_list",
                                                            label:
                                                              _vm.selectedType ===
                                                              3
                                                                ? _vm.$t(
                                                                    "transactionID"
                                                                  )
                                                                : _vm.$t(
                                                                    "organizationName"
                                                                  )
                                                          },
                                                          on: {
                                                            keyup: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                !$event.type.indexOf(
                                                                  "key"
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "enter",
                                                                  13,
                                                                  $event.key,
                                                                  "Enter"
                                                                )
                                                              ) {
                                                                return null
                                                              }
                                                              _vm.refresh = !_vm.refresh
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.searchName,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.searchName = $$v
                                                            },
                                                            expression:
                                                              "searchName"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  ),
                                  model: {
                                    value: _vm.transferHistory,
                                    callback: function($$v) {
                                      _vm.transferHistory = $$v
                                    },
                                    expression: "transferHistory"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index === 3 && _vm.tab === 3
                              ? _c("ProductStatistics", {
                                  model: {
                                    value: _vm.productId,
                                    callback: function($$v) {
                                      _vm.productId = $$v
                                    },
                                    expression: "productId"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index === 4 && _vm.tab === 4
                              ? _c("OutBoundHistoryTable", {
                                  attrs: { upc: _vm.product.upc }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  2
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a991620", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a991620","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductDetail.vue
// module id = null
// module chunks = 